import contract from '../../contracts/deployment-status.json';

const HTTP_NOT_FOUND = 404;

export type DeploymentPhase = keyof typeof contract.phases;

export function readDeploymentPhase(value: unknown): DeploymentPhase | null {
  if (!value || typeof value !== 'object' || !('version' in value) || value.version !== contract.version
    || !('phase' in value) || typeof value.phase !== 'string' || !Object.hasOwn(contract.phases, value.phase)) return null;
  return value.phase as DeploymentPhase;
}

export function isDeploymentActive(phase: DeploymentPhase | null): boolean {
  return phase !== null && contract.phases[phase].active;
}

/** Older web servers have no status route. A transport outage preserves a known update. */
export async function fetchDeploymentPhase(signal: AbortSignal, previous: DeploymentPhase | null): Promise<DeploymentPhase | null> {
  try {
    const response = await fetch(contract.endpoint, { cache: 'no-store', signal });
    return response.ok ? readDeploymentPhase(await response.json()) : response.status === HTTP_NOT_FOUND ? null : previous;
  } catch {
    return previous;
  }
}
